export default {
  activeVersion: 'v1',
  baseUrl: 'https://shared.mediahuis.be/logos/sw/',
  alt: 'Sunday World',
  v1: {
    main: {
      'brand-main': {
        png: 'brand-main.png',
        svg: 'brand-main.svg'
      },
      'brand-square-main': {
        png: 'brand-square-main.png',
        svg: 'brand-square-main.svg'
      },
      'brand-plus-main': {
        png: 'brand-plus-main.png',
        svg: 'brand-plus-main.svg',
        alt: 'Plus Artikel'
      }
    }
  }
};